
/**
 * Compares the 2 given version strings and returns the result as an int:
 * -1 means ver1 < ver2
 * 0 means ver1 = ver2
 * 1 means ver1 > ver2
 */
export function compareVersions(ver1, ver2) {
    const ver1Split = ver1.split(".")
    const ver2Split = ver2.split(".")

    const ver1Major = parseInt(ver1Split[0])
    const ver1Minor = parseInt(ver1Split[1])
    // const ver1Build = ver1Split.length = 3 ? ver1Split[2] : undefined // Optional, may not exist
    const ver1Build = parseInt(ver1Split[2])

    const ver2Major = parseInt(ver2Split[0])
    const ver2Minor = parseInt(ver2Split[1])
    // const ver2Build = ver2Split.length = 3 ? ver2Split[2] : undefined // Optional, may not exist
    const ver2Build = parseInt(ver2Split[2])

    if (ver1Major < ver2Major) {
        return -1;
    } else if (ver1Major > ver2Major) {
        return 1;
    // } else if (ver1Major === ver2Major) {
    } else {
        if (ver1Minor < ver2Minor) {
            return -1;
        } else if (ver1Minor > ver2Minor) {
            return 1;
        // } else if (ver1Minor === ver2Minor) {
        } else {
            if (ver1Build < ver2Build) {
                return -1;
            } else if (ver1Build > ver2Build) {
                return 1;
            // } else if (ver1Build === ver2Build) {
            } else {
                return 0;
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/Helpers/version.js